import AttendanceStatusBlock from "./attendance-status-block";


const AttendanceBlocks = {
    Status: AttendanceStatusBlock
};

export {
    AttendanceStatusBlock
};

export default AttendanceBlocks;
